<template>
    <a
            class="item"
            style="border-radius: 0"
            :class="classObject"
            :title="title"
            @click="onItemClick">
        <font-awesome-icon :icon="['fas',icon]" size="lg"/>
    </a>
</template>

<script>
    import Vue from 'vue'

    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faGamepad} from '@fortawesome/free-solid-svg-icons'

    library.add(faGamepad);

    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

    export default {
        props: {
            icon: {
                type: String,
                default: 'gamepad'
            },
            title: {
                type: String,
                default: null
            },
            isActive: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        computed: {
            classObject: function () {
                return {
                    active: this.isActive
                }
            }
        },
        methods: {
            onItemClick:function () {
                this.$emit('itemClick');
            }
        },

        components: {
            FontAwesomeIcon
        }

    }
</script>

<style scoped>

</style>
